// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectBorder{border-width:2px!important}.btnBaseCss{word-wrap:break-word;align-items:center;border:1px solid #ccc;box-sizing:border-box;display:flex;flex-direction:row;justify-content:center;background:#f1f1ff;border:1.5px solid #4a669e;border-radius:8px;flex:none;order:0;flex-grow:0;min-height:30px}", ""]);
// Exports
module.exports = exports;
